export default "__VITE_ASSET__CuuHwazf__"